<template>
   <RouterLink :to="to_url" id="back-button" class="bg-transparent text-white border hover:border-white/50 border-transparent py-2 px-4 rounded-[50px] box-border hover:shadow-lg hover:shadow-white/70 transition-shadow duration-500">
      Cancel
   </RouterLink>
</template>

<script>

export default {
   name: 'BackButton',
   props: {
      to_url: String,
   }
}
</script>